import { HttpClient } from 'api/http-client';

class TimesheetsApiClient extends HttpClient {}
export const client = new TimesheetsApiClient();
